import { ReactElement } from 'react';
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

import { HeaderProvider } from '@gn-audio/jss-components';
import { AppHeader } from '@gn-audio/jss-components/components';
import { useSiteSettings } from '@gn-audio/jss-components/utils/contexts';
import { getFullSiteSettings as jssGetFullSiteSettings } from '@gn-audio/jss-core';

import { getFullSiteSettings } from 'api/siteSettings/siteSettingsApi';
import { CondensedMenuComponent } from 'common/condensedMenu/CondensedMenuComponent';
import { useCondensedMenu } from 'common/condensedMenu/CondensedMenuProvider';
import { ComponentProps } from 'lib/component-props';

import { MenuItem } from './types';

type HeaderProps = ComponentProps & {
  fields: {
    MenuItems: MenuItem[];
    MenuItemsShared: MenuItem[];
  };
};

const Header = ({ fields }: HeaderProps): ReactElement => {
  const {
    sitecoreContext: { route, language },
  } = useSitecoreContext();
  const { myjabra } = useSiteSettings();
  const { showMenu, menuItems } = useCondensedMenu();
  const handleLanguageSelect = () => {
    getFullSiteSettings.cache.clear?.();
    jssGetFullSiteSettings.cache.clear?.();
  };

  return (
    <HeaderProvider
      currentLocale={language}
      route={route}
      myJabraUrl={myjabra?.baseUrl}
      fields={fields}
      onLanguageSelect={handleLanguageSelect}
    >
      <AppHeader
        condensedMenu={showMenu || menuItems.length ? <CondensedMenuComponent /> : undefined}
      />
    </HeaderProvider>
  );
};

export default withDatasourceCheck()<HeaderProps>(Header);
